import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const defEvents = {
    before: AppConstants.LINKS_START_LOADING,
    success: AppConstants.LINKS_SEARCH_SUCCESS,
    fail: AppConstants.LINKS_FAIL
};

const PromoCodeActions = {
    getListLinks(params, callback, events = defEvents) {
        if (events.before) {
            dispatch({
                type  : events.before
            });
        }

        api.searchLinks(params)
            .then(data => {
                if (events.success) {
                    dispatch({
                        type: events.success,
                        items: data.response || {}
                    });
                }

                callback && callback(data.response);
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },

    savePromoCode(params) {
        return api.savePromoCode(params);
    },

    validatePromoCode(params) {
        return api.validatePromoCode(params);
    },

    editPromoCode(params) {
        return api.editPromoCode(params);
    },

    deletePromoCode(params) {
        return api.deletePromoCode(params);
    }
};

export default PromoCodeActions;
